import React from 'react';
import Avatar from 'material-ui/Avatar'
import Menu, {MenuItem} from 'material-ui/Menu';
import * as userManage from 'engine/userManagements';
import {urlPrefix} from 'engine/dataServices';

class UserInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            avatar: '',
            anchorEl: null,
            open: false,
        }
    }

    componentWillMount() {
        this.loadAvatar();
    }

    loadAvatar() {
        let avatar = localStorage.getItem('userImage');
        avatar = (avatar) && avatar.toLowerCase() != 'null' ? urlPrefix + avatar : require('assets/Images/TolitonAvatar.png');
        this.setState({avatar});
    }

    handleClick = event => {
        this.setState({open: true, anchorEl: event.currentTarget});
    };

    handleRequestClose = () => {
        this.setState({open: false});
    };

    render() {
        const {avatar} = this.state;

        return (
            <div className="user-profile d-flex flex-row align-items-center">
                <Avatar
                    alt='...'
                    src={avatar}
                    className="user-avatar "
                />
                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{localStorage.getItem('userName')}
                        <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
                    </h4>
                </div>
                <Menu className="user-info"
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onClose={this.handleRequestClose}
                      PaperProps={{
                          style: {
                              width: 120,
                              paddingTop: 0,
                              paddingBottom: 0
                          }
                      }}
                >
                    <MenuItem onClick={userManage.logout}><i
                        className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>خروج
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

export default UserInfo;




// WEBPACK FOOTER //
// ./components/UserInfo/index.js